export default __webpack_public_path__ + "static/media/betyakata-logo.efb6ccbf.png";